import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import type { FileWithPath } from 'react-dropzone';
import { toast } from 'react-toastify';

import { CloudUploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Row, Spin } from 'antd';

import uploadService from 'v2/services/upload';

import { FormContent } from '../../EditProduct/components/FormContent';

interface IProps {
  onUpload: (upload_id: number) => void;
  onRemove: () => void;
}

export const PrivateLabelRights = ({ onUpload, onRemove }: IProps) => {
  const [file, setFile] = useState<FileWithPath>();
  const [uploading, setUploading] = useState<boolean>(false);

  const onDrop = (files: FileWithPath[]) => {
    const f = [...files].shift();
    onUploadFile(f);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false
  });

  const onUploadFile = useCallback(
    (file: FileWithPath) => {
      setUploading(true);
      uploadService
        .uploadFile(file, 'private_label_rights')
        .then((response: { data: { upload_id: number } }) => {
          setFile(file);
          onUpload(response.data.upload_id);
          setUploading(false);
        })
        .catch(() => {
          toast.error('Falha ao subir arquivo, tente novamente');
          setFile(null);
          setUploading(false);
        });
    },
    [onUpload]
  );

  const handleRemove = () => {
    setFile(null);
    onRemove();
  };

  return (
    <FormContent title='Direitos privados de etiqueta' loading={false}>
      <Row gutter={16}>
        <Col span={24}>
          <p className='[&:not(:last-of-type)]:mb-4'>
            Caso o conteúdo não seja de sua autoria, é necessário preencher&nbsp;
            <a
              href='https://drive.google.com/file/d/0B49AZsMzd09sU3YxU3BXYUliZGc/view?resourcekey=0-3uLUHC6Oatpm7UguZ1kN3A'
              target='_blank'
              rel='noopener noreferrer'
            >
              este documento
            </a>
            &nbsp; e anexá-lo no campo abaixo. Se você for o autor deste conteúdo, pode pular esta etapa.
          </p>

          <div className='mb-2 font-bold'>Por que preciso fazer isso?</div>
          <p className='[&:not(:last-of-type)]:mb-4'>
            Confira&nbsp;
            <a
              href='https://ajuda.eduzz.com/hc/pt-br/articles/8004679566107-o-que-%C3%A9-e-como-cadastrar-meu-produto-plr-na-eduzz'
              target='_blank'
              rel='noopener noreferrer'
            >
              este artigo
            </a>
            &nbsp;para entender todos os detalhes.
          </p>
        </Col>

        <Col span={24}>
          {!uploading && file && (
            <>
              <h4>Arquivo</h4>
              <div className='flex items-center justify-between rounded-md border border-[#eeeeee] bg-white px-3 py-1 break-all'>
                <span>{file.name}</span>
                <Button type='text' icon={<DeleteOutlined size={15} />} onClick={handleRemove} />
              </div>
            </>
          )}
          {!file && (
            <div
              id='drag-and-drop-plr'
              {...getRootProps({
                className:
                  'p-6 border-2 rounded-xs border-[#eeeeee] border-dashed bg-[#fafafa] transition-[border] duration-300 ease-in-out h-full text-center text-text-heading cursor-pointer flex items-center justify-center [&>p]:ml-2'
              })}
            >
              {uploading && (
                <Spin size='large'>
                  <span>Por favor aguarde, estamos fazendo upload do arquivo.</span>
                </Spin>
              )}
              {!uploading && (
                <>
                  <input {...getInputProps()} />
                  <CloudUploadOutlined style={{ fontSize: 24, marginRight: 10 }} />
                  <span>Selecione ou arraste seu arquivo de PLR (Direitos Privados de Etiqueta)</span>
                </>
              )}
            </div>
          )}
        </Col>
      </Row>
    </FormContent>
  );
};
